<template lang="pug">
  .bg-gray-300.h-screen.w-screen.flex.justify-center.items-center
    form.bg-white.shadow-md.rounded.px-8.pt-6.pb-8.mb-4
      h3.font-bold.uppercase.mb-6.text-gray-700 Ingrese sus credenciales

      .mb-4
        label.block.text-grey-darker.text-sm.font-bold.mb-2 
          | Usuario
          input.shadow.appearance-none.border.rounded.w-full.py-2.px-3.text-grey-darker(type="text", v-model="username", @keyup.enter="login")

      .mb-4
        label.block.text-grey-darker.text-sm.font-bold.mb-2 
          | Password
          input.shadow.appearance-none.border.rounded.w-full.py-2.px-3.text-grey-darker(type="password", v-model="password", @keyup.enter="login")
      
      .bg-blue-400.text-white.font-bold.py-2.px-4.rounded.cursor-pointer(@click="login") Ingresar

</template>

<script>
import { apiPost, notify } from '../util/general'
export default {
  name: 'login',
  data () {
    return {
      usuario: '',
      username    : '',
      password    : '',
      isLoading   : false
    }
  },
  methods: {
    login () {
      var vm          = this
      var url = '/usuario'
      vm.isLoading    = true

      var obj = {
        username: vm.username,
        password: vm.password
      }

      apiPost(vm, url, obj, function (data) {
        console.log('data:', data)
        localStorage.setItem('token', data.token)
        localStorage.setItem('nombre', data.nombre)
        localStorage.setItem('usuario', data.usuario)
        localStorage.setItem('perfil', data.perfil)
        localStorage.setItem('_id', data._id)
        window.location.reload(true)
      }, function (error) {
        console.log('error.message:', error.message)
        notify(vm, 'error', 'Error', error.message)
        vm.isLoading    = false
      }, function () {
        vm.isLoading = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// view_login.vue?7d1ff839